import LoadingCircle from '../../../utils/loading';

class Sotk {
  constructor() {
    this._render();
    this.sotkData = [];
  }

  _render() {
    document.title = 'Tagawiti Dashboard - SOTK';

    const sotkContentContainer = document.createElement('div');
    sotkContentContainer.className = 'sotk-content-container';

    sotkContentContainer.innerHTML = `
      <header>
        <h1>Struktur Organisasi dan Tata Kerja</h1>
        <button id="addSotkBtn" class="btn-add-main">Tambah SOTK</button>
      </header>
      <section id="sotkSection" class="crud-section">
        <div class="table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>No</th>
                <th>Foto</th>
                <th>Nama</th>
                <th>Jabatan</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody id="sotkTableBody">
            </tbody>
          </table>
        </div>
      </section>
      <div id="sotkModalOverlay" style="display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.5); z-index: 1000;">
        <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); background: white; padding: 2rem; border-radius: 8px; min-width: 400px; z-index: 1001; box-shadow: 0 4px 6px rgba(0,0,0,0.1);">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1.5rem;">
            <h5 id="modalTitle" style="margin: 0; font-weight: 600;">Tambah SOTK</h5>
            <button id="closeModalBtn" style="background: none; border: none; font-size: 1.5rem; cursor: pointer;">&times;</button>
          </div>
          <form id="sotkForm">
            <div style="margin-bottom: 1rem;">
              <label for="sotkName" style="display: block; margin-bottom: 0.5rem; font-weight: 500;">Nama</label>
              <input type="text" class="form-control" id="sotkName" required>
            </div>
            <div style="margin-bottom: 1rem;">
              <label for="sotkPosition" style="display: block; margin-bottom: 0.5rem; font-weight: 500;">Jabatan</label>
              <input type="text" class="form-control" id="sotkPosition" required>
            </div>
            <div style="margin-bottom: 1.5rem;">
              <label for="sotkPhoto" style="display: block; margin-bottom: 0.5rem; font-weight: 500;">Foto</label>
              <input type="file" class="form-control" id="sotkPhoto" accept="image/*">
              <small style="color: #666; margin-top: 0.25rem; display: block;">Format: JPG, PNG, WebP (Max 5MB)</small>
            </div>
            <div style="display: flex; gap: 0.5rem; justify-content: flex-end;">
              <button type="button" id="cancelModalBtn" class="btn btn-secondary">Batal</button>
              <button type="button" id="submitBtn" class="btn btn-primary">Simpan</button>
            </div>
          </form>
        </div>
      </div>
    `;

    return sotkContentContainer;
  }

  _showModal() {
    document.getElementById('sotkModalOverlay').style.display = 'block';
  }

  _hideModal() {
    document.getElementById('sotkModalOverlay').style.display = 'none';
    document.getElementById('sotkForm').reset();
    this.currentEditId = null;
  }

  async InitializeEvent() {
    const loadingIndicator = new LoadingCircle();
    try {
      loadingIndicator.show();
      await this._fetchSotkData();
      this._renderSotkTable();
      this._setupEventListeners();
    } catch (error) {
      console.error('Error initializing SOTK event:', error);
    } finally {
      loadingIndicator.hide();
    }
  }

  async _fetchSotkData() {
    try {
      const response = await fetch('https://api.desatagawiti.com/api/get/sotk', {
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error('Failed to fetch SOTK data');
      }

      const result = await response.json();
      this.sotkData = result.data || [];
    } catch (error) {
      console.error('Error fetching SOTK data:', error);
      this.sotkData = [];
    }
  }

  _renderSotkTable() {
    const tableBody = document.getElementById('sotkTableBody');
    tableBody.innerHTML = '';

    if (this.sotkData.length === 0) {
      tableBody.innerHTML = '<tr><td colspan="5" class="text-center">Belum ada data SOTK</td></tr>';
      return;
    }

    this.sotkData.forEach((item, index) => {
      const row = document.createElement('tr');
      // Convert relative paths to absolute backend URLs
      const photoUrl = item.photo_url.startsWith('http') ? item.photo_url : `https://api.desatagawiti.com${item.photo_url}`;

      row.innerHTML = `
        <td>${index + 1}</td>
        <td><img src="${photoUrl}" alt="${item.name}" style="width: 50px; height: 50px; object-fit: cover; border-radius: 5px;"></td>
        <td>${item.name}</td>
        <td>${item.position_title}</td>
        <td>
          <button class="btn btn-sm btn-warning edit-btn" data-id="${item.id}">Edit</button>
          <button class="btn btn-sm btn-danger delete-btn" data-id="${item.id}">Hapus</button>
        </td>
      `;
      tableBody.appendChild(row);
    });
  }

  _setupEventListeners() {
    const addBtn = document.getElementById('addSotkBtn');
    addBtn.addEventListener('click', () => this._showAddForm());

    const closeBtn = document.getElementById('closeModalBtn');
    const cancelBtn = document.getElementById('cancelModalBtn');
    closeBtn.addEventListener('click', () => this._hideModal());
    cancelBtn.addEventListener('click', () => this._hideModal());

    const editBtns = document.querySelectorAll('.edit-btn');
    editBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const id = e.target.dataset.id;
        this._showEditForm(id);
      });
    });

    const deleteBtns = document.querySelectorAll('.delete-btn');
    deleteBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const id = e.target.dataset.id;
        this._deleteSotk(id);
      });
    });
  }

  _showAddForm() {
    document.getElementById('modalTitle').innerText = 'Tambah SOTK Baru';
    document.getElementById('sotkForm').reset();
    this.currentEditId = null;
    this._showModal();

    document.getElementById('submitBtn').onclick = () => {
      const name = document.getElementById('sotkName').value;
      const position_title = document.getElementById('sotkPosition').value;
      const photoFile = document.getElementById('sotkPhoto').files[0];

      if (!photoFile && !name && !position_title) {
        alert('Mohon isi semua field');
        return;
      }

      this._addSotk(name, position_title, photoFile);
      this._hideModal();
    };
  }

  _showEditForm(id) {
    const sotk = this.sotkData.find((item) => item.id === parseInt(id));
    if (!sotk) return;

    document.getElementById('modalTitle').innerText = 'Edit SOTK';
    document.getElementById('sotkName').value = sotk.name;
    document.getElementById('sotkPosition').value = sotk.position_title;
    document.getElementById('sotkPhoto').value = ''; // Clear file input
    this.currentEditId = id;
    this._showModal();

    document.getElementById('submitBtn').onclick = () => {
      const name = document.getElementById('sotkName').value;
      const position_title = document.getElementById('sotkPosition').value;
      const photoFile = document.getElementById('sotkPhoto').files[0];

      this._updateSotk(id, name, position_title, photoFile);
      this._hideModal();
    };
  }

  async _addSotk(name, position_title, photoFile) {
    const loadingIndicator = new LoadingCircle();
    try {
      loadingIndicator.show();

      const formData = new FormData();
      formData.append('name', name);
      formData.append('position_title', position_title);
      if (photoFile) {
        formData.append('photo', photoFile);
      }

      const response = await fetch('https://api.desatagawiti.com/api/add/sotk', {
        method: 'POST',
        body: formData,
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error('Failed to add SOTK');
      }

      await this._fetchSotkData();
      this._renderSotkTable();
      this._setupEventListeners();

      alert('SOTK berhasil ditambahkan!');
    } catch (error) {
      console.error('Error adding SOTK:', error);
      alert('Gagal menambahkan SOTK');
    } finally {
      loadingIndicator.hide();
    }
  }

  async _updateSotk(id, name, position_title, photoFile) {
    const loadingIndicator = new LoadingCircle();
    try {
      loadingIndicator.show();

      const formData = new FormData();
      formData.append('name', name);
      formData.append('position_title', position_title);
      if (photoFile) {
        formData.append('photo', photoFile);
      }

      const response = await fetch(`https://api.desatagawiti.com/api/update/sotk/${id}`, {
        method: 'PUT',
        body: formData,
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error('Failed to update SOTK');
      }

      await this._fetchSotkData();
      this._renderSotkTable();
      this._setupEventListeners();

      alert('SOTK berhasil diperbarui!');
    } catch (error) {
      console.error('Error updating SOTK:', error);
      alert('Gagal memperbarui SOTK');
    } finally {
      loadingIndicator.hide();
    }
  }

  async _deleteSotk(id) {
    if (!confirm('Apakah Anda yakin ingin menghapus SOTK ini?')) return;

    const loadingIndicator = new LoadingCircle();
    try {
      loadingIndicator.show();

      const response = await fetch(`https://api.desatagawiti.com/api/delete/sotk/${id}`, {
        method: 'DELETE',
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error('Failed to delete SOTK');
      }

      await this._fetchSotkData();
      this._renderSotkTable();
      this._setupEventListeners();

      alert('SOTK berhasil dihapus!');
    } catch (error) {
      console.error('Error deleting SOTK:', error);
      alert('Gagal menghapus SOTK');
    } finally {
      loadingIndicator.hide();
    }
  }
}

export default Sotk;
